import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { User } from 'app/modules/user-management/models/user.model';
import { DataService } from 'app/shared/services/data.service';
import { Injectable } from '@angular/core';

@Injectable()
export class TwoFactorService extends DataService<User> {

  constructor(protected dependencies: ApiDependenciesService) {
    super(dependencies);
    this.endpoint = '/users';
  }

  get baseEndpoint(): string {
    return this.endpoint;
  }

  baseEndpointWithId(id: number): string {
    return this.baseEndpoint + '/' + id;
  }


  public async getUserInfoTwoFactorAuth(): Promise<any> {
    let model: any;

    await this.setEndpoint(this.baseEndpoint + '/secret-enabled')
    .save({
    })
      .then((response: any) => {
        model = response;
      });

    return Promise.resolve(model);
  }

  public async refreshUserSecret(): Promise<any> {
    let model: any;

    await this.setEndpoint(this.baseEndpoint + '/refresh-secret')
      .save({
      })
      .then((response: any) => {
        model = response;
      });

    return Promise.resolve(model);
  }

  public async disableTwoFactorAuth(): Promise<any> {
    let model: any;

    await this.setEndpoint(this.baseEndpoint + '/disable-secret')
      .save({
      })
      .then((response: any) => {
        model = response;
      });

    return Promise.resolve(model);
  }

  public async confirmUserSecret(id: number, secret: string, otp: string): Promise<any> {
    let model: any;

    await this.setEndpoint(this.baseEndpoint + '/confirm-secret')
      .save({
        id: id,
        secret: secret,
        otp: otp
      })
      .then((response: any) => {
        model = response;
      });

    return Promise.resolve(model);
  }

  protected handleError(error: any, request: any): Promise<any> {
    return this.handleApiError(error, request);
  }


}
